/**
 * @file dev-localhost.ts
 * @description dev-адреса магазина `<slug>.localhost` — phase19.28 этап А
 * (db-design-domains-a §3 п. 3): вне production магазин узнаётся по slug в
 * адресе `http://chaiberi.localhost:3005`; браузеры сами направляют
 * `*.localhost` на 127.0.0.1, поэтому ни hosts-файла, ни `?shop=` не нужно.
 *
 * Решение о том, включать ли dev-резолв (только не production), принимает
 * вызывающий — здесь только разбор адреса.
 */

const LOCALHOST = "localhost";

/** Одна DNS-метка — slug в dev-адресе (резерв не проверяем: это dev). */
const DNS_LABEL = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

/** Нижний регистр, без порта и завершающей точки — сырой Host тоже подходит. */
function cleanup(host: string): string {
  return host.trim().toLowerCase().replace(/:\d*$/, "").replace(/\.$/, "");
}

/** `localhost` или `<slug>.localhost` (ровно одна метка перед `.localhost`). */
export function isDevLocalhostHost(host: string): boolean {
  const value = cleanup(host);
  return value === LOCALHOST || shopSlugFromLocalhost(value) !== null;
}

/** slug из `<slug>.localhost`; null — это не dev-адрес магазина (в том числе голый `localhost`). */
export function shopSlugFromLocalhost(host: string): string | null {
  const value = cleanup(host);
  const suffix = `.${LOCALHOST}`;
  if (!value.endsWith(suffix)) return null;
  const label = value.slice(0, -suffix.length);
  return DNS_LABEL.test(label) ? label : null;
}
